<sb-modal-template [templateId]="templateId">
  <div modal-header>
    <h5 class="modal-title">{{ options.title }} </h5>
  </div>
  <div modal-body>
    <p>{{ options.message }}</p>
  </div>
  <div modal-footer>
    <button class="btn btn-primary mr-1" (click)="yes()">{{options.yes ? options.yes : "YES"}}</button>
    <button class="btn btn-default" (click)="no()">{{options.no ? options.no : "NO"}}</button>
  </div>
</sb-modal-template>
